// RFC 4647 lookup: match the BCP-47 tag the shell sends against the catalogues AO actually has.
// The shell's `locales` setting and AO's `availableLocales` are configured separately, so a tag AO
// cannot serve is ignored rather than applied — see shell-locale.js for what applying one costs.
//
// Truncation only: `de-DE` finds `de`, `de` does not find `de-DE`.
//
// Copied per product repo, like the auth middleware. The shell's is
// client/src/locales/resolve-locale.ts in rtls-one-retail.

// Case carries meaning in BCP-47 by convention only, so `en-gb` in a config override and `en-GB`
// from the shell have to compare equal. Language lowercase, region uppercase, script title case.
export function canonicalizeTag(tag) {
  const [language, ...subtags] = String(tag).trim().split('-');
  return [
    language.toLowerCase(),
    ...subtags.map(subtag => {
      if (subtag.length === 2) return subtag.toUpperCase();
      if (subtag.length === 4) return subtag[0].toUpperCase() + subtag.slice(1).toLowerCase();
      return subtag.toLowerCase();
    }),
  ].join('-');
}

// The available tag that serves `requested`, or null to leave AO's current locale alone. Returns the
// tag as `available` spelled it, not as canonicalized: it indexes message catalogues and filenames,
// where `en-XA` and `en-xa` are different keys.
export function resolveLocale(requested, available) {
  if (!requested) return null;
  const byCanonical = new Map(available.map(tag => [canonicalizeTag(tag), tag]));
  const subtags = canonicalizeTag(requested).split('-');
  while (subtags.length) {
    const hit = byCanonical.get(subtags.join('-'));
    if (hit) return hit;
    subtags.pop();
  }
  return null;
}
